import React from 'react'
import HorizontalLine from '../Design/HorizontalLine'
import LinkButton from '../Design/LinkButton'

const Welcome = () => (
  <div>
    <h2 className='fade-in text-shadow'>
      <span className='block roboto font75 ls25 white'>Take control of your finances </span>
      <span className='block roboto font75 ls25 white'>by knowing where your money is.</span>
    </h2>
    <HorizontalLine
      color='bg-middle-blue'
      width='7em'
      margin='2em auto 3em'
    />
    <LinkButton
      addClass='button-1 font125 ls50 ml mr'
      sendTo='/login'
      text='Login'
    />
    <LinkButton
      addClass='button-1 font125 ls50 mt mb ml mr'
      sendTo='/signup'
      text='Sign up'
    />
  </div>
)

export default Welcome
